<template>
  <div>
    <v-card
      minHeight="120"
      hover
      tile
    >
      <v-avatar
        v-if="report.status"
        tile
        class="float-right"
        :color="iconColor"
        size="36"
      >
        <v-icon
          size="24"
          color="white"
        >
          {{ iconStatus }}
        </v-icon>
      </v-avatar>
      <v-card-title>
        {{ report.client }}
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="4">
              {{ report.author }}
            </v-col>
            <v-col cols="4">
              <p
                :class="reportStatusColor"
                class="dot alert"
              />
              {{ report.status | capitalize }}
            </v-col>
            <v-col
              cols="4"
            >
              <v-icon small>
                mdi-clock-outline
              </v-icon>
              {{ report.date }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
    name: 'RecentReports',
    props: {
        report: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            iconStatus: null,
            iconColor: null,
        };
    },
    computed: {
        reportStatusColor() {
            return (this.report.status === 'completed') ? 'green' : 'deep-orange darken-2';
        },
    },
    created() {
        this.setIcon();
    },
    methods: {
        setIcon() {
            switch (this.report.status) {
                case 'completed':
                    this.iconStatus = 'mdi-pdf-box';
                    this.iconColor = 'deep-orange darken-2';
                    break;
                case 'in progress':
                    this.iconStatus = 'mdi-pencil-outline';
                    this.iconColor = 'grey';
                    break;
                default:
            }
        },
    },
};
</script>
